'use strict';

exports.__esModule = true;
exports.default = undefined;

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _desc, _value, _class, _class2, _temp;

var _cssElementQueries = require('css-element-queries');

var _constants = require('playable/dist/src/constants');

var _playerApiDecorator = require('playable/dist/src/core/player-api-decorator');

var _playerApiDecorator2 = _interopRequireDefault(_playerApiDecorator);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _cardsContainer = require('./cards-container/cards-container');

var _cardsContainer2 = _interopRequireDefault(_cardsContainer);

var _cardsManager = require('./cards-manager/cards-manager');

var _cardsManager2 = _interopRequireDefault(_cardsManager);

var _cardsConfig = require('./cards-config/cards-config');

var _cardsConfig2 = _interopRequireDefault(_cardsConfig);

var _constants2 = require('./constants');

var _domUpdateDelay = require('./utils/dom-update-delay');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var CardsModule = (_dec = (0, _playerApiDecorator2.default)(), _dec2 = (0, _playerApiDecorator2.default)(), _dec3 = (0, _playerApiDecorator2.default)(), _dec4 = (0, _playerApiDecorator2.default)(), _dec5 = (0, _playerApiDecorator2.default)(), _dec6 = (0, _playerApiDecorator2.default)(), _dec7 = (0, _playerApiDecorator2.default)(), _dec8 = (0, _playerApiDecorator2.default)(), _dec9 = (0, _playerApiDecorator2.default)(), _dec10 = (0, _playerApiDecorator2.default)(), _dec11 = (0, _playerApiDecorator2.default)(), _dec12 = (0, _playerApiDecorator2.default)(), (_class = (_temp = _class2 = function () {
  function CardsModule(_ref) {
    var eventEmitter = _ref.eventEmitter,
        rootContainer = _ref.rootContainer,
        engine = _ref.engine;

    _classCallCheck(this, CardsModule);

    this.eventEmitter = eventEmitter;
    this.rootContainer = rootContainer;
    this.engine = engine;
    this.cardsConfig = new _cardsConfig2.default();

    this.isInitialized = false;

    this.hide = _noop2.default;
    this.show = _noop2.default;

    this.handlePlayerSizeChange = this.handlePlayerSizeChange.bind(this);
  }

  // Lazy initialization of cards-related stuff


  CardsModule.prototype.initialize = function initialize() {
    var _this = this;

    if (this.isInitialized) {
      return;
    }

    this.initContainer();
    this.initManager();
    this.initEventListeners();

    this.hide = function () {
      return _this.cardsContainer.hide();
    };
    this.show = function () {
      return _this.cardsContainer.show();
    };

    this.isInitialized = true;

    setTimeout(function () {
      return _this.handlePlayerStateChange({ nextState: _this.engine.getCurrentState() });
    }, 0);
  };

  CardsModule.prototype.initContainer = function initContainer() {
    this.cardsContainer = new _cardsContainer2.default({ cardsConfig: this.cardsConfig });
    this.rootContainer.appendComponentElement(this.cardsContainer.node);
  };

  CardsModule.prototype.initManager = function initManager() {
    this.cardsManager = new _cardsManager2.default({
      cardsContainer: this.cardsContainer,
      eventEmitter: this.eventEmitter,
      cardsConfig: this.cardsConfig,
      engine: this.engine
    });
  };

  CardsModule.prototype.initEventListeners = function initEventListeners() {
    var _this2 = this;

    this.eventEmitter.on(_constants.VIDEO_EVENTS.STATE_CHANGED, this.handlePlayerStateChange, this);

    this.eventEmitter.on(_constants.UI_EVENTS.MAIN_BLOCK_HIDE, this.cardsContainer.onControlsHidden, this.cardsContainer);
    this.eventEmitter.on(_constants.UI_EVENTS.MAIN_BLOCK_SHOW, this.cardsContainer.onControlsShown, this.cardsContainer);

    // wait for playerContainerNode inserted to DOM and get size for case if it's not added yet
    (0, _domUpdateDelay.waitForDomUpdate)().then(function () {
      return _this2.resizeSensor = new _cssElementQueries.ResizeSensor(_this2.rootContainer.getElement(), _this2.handlePlayerSizeChange);
    });

    this.eventEmitter.on(_constants2.EVENTS.CARD_CLOSED, this.cardsManager.handleCardClose, this.cardsManager);
  };

  CardsModule.prototype.addCard = function addCard(cardData) {
    this.initialize();
    return this.cardsManager.addCard(cardData);
  };

  CardsModule.prototype.addCards = function addCards(cardsData) {
    this.initialize();
    return this.cardsManager.addCards(cardsData);
  };

  CardsModule.prototype.removeCard = function removeCard(id) {
    this.cardsManager.removeCard(id);
  };

  CardsModule.prototype.updateCards = function updateCards(cardsData) {
    return this.cardsManager.updateCards(cardsData);
  };

  CardsModule.prototype.clearCards = function clearCards() {
    if (!this.isInitialized) {
      return;
    }
    this.cardsManager.clearCards();
  };

  CardsModule.prototype.setAnchorPoint = function setAnchorPoint(anchorPoint) {
    if (this.cardsConfig.anchorPoint === anchorPoint) {
      return;
    }
    this.cardsConfig.anchorPoint = anchorPoint;
  };

  CardsModule.prototype.setOrientation = function setOrientation(orientation) {
    if (this.cardsConfig.orientation === orientation) {
      return;
    }
    this.cardsConfig.orientation = orientation;
  };

  CardsModule.prototype.onCardClose = function onCardClose(callback) {
    this.eventEmitter.on(_constants2.EVENTS.CARD_CLOSED, callback);
  };

  CardsModule.prototype.onCardShown = function onCardShown(callback) {
    this.eventEmitter.on(_constants2.EVENTS.CARD_SHOWN, callback);
  };

  CardsModule.prototype.onCardHidden = function onCardHidden(callback) {
    this.eventEmitter.on(_constants2.EVENTS.CARD_HIDDEN, callback);
  };

  CardsModule.prototype.setCardsClosable = function setCardsClosable(isClosable) {
    var isPreviewMode = !isClosable;

    if (this.cardsConfig.isPreviewMode === isPreviewMode) {
      return;
    }

    this.cardsConfig.isPreviewMode = isPreviewMode;
  };

  CardsModule.prototype.setActiveCard = function setActiveCard(id) {
    if (this.isInitialized) {
      return this.cardsManager.showSelectedCard(id);
    }
  };

  CardsModule.prototype.handlePlayerSizeChange = function handlePlayerSizeChange() {
    this.cardsManager.handlePlayerSizeChange();
  };

  CardsModule.prototype.handlePlayerStateChange = function handlePlayerStateChange(_ref2) {
    var nextState = _ref2.nextState;

    switch (nextState) {
      case _constants.EngineState.PLAYING:
        this.cardsManager.handleVideoPlayStart();
        break;
      case _constants.EngineState.PAUSED:
        this.cardsManager.handleVideoPlayPause();
        break;
      case _constants.EngineState.SEEK_IN_PROGRESS:
        this.cardsManager.handleSeekPositionChange();
        break;
      default:
        break;
    }
  };

  CardsModule.prototype.unbindEvents = function unbindEvents() {
    this.eventEmitter.off(_constants.VIDEO_EVENTS.STATE_CHANGED, this.handlePlayerStateChange, this);

    this.eventEmitter.off(_constants.UI_EVENTS.MAIN_BLOCK_HIDE, this.cardsContainer.onControlsHidden, this.cardsContainer);
    this.eventEmitter.off(_constants.UI_EVENTS.MAIN_BLOCK_SHOW, this.cardsContainer.onControlsShown, this.cardsContainer);

    this.eventEmitter.off(_constants2.EVENTS.CARD_CLOSED);
    this.eventEmitter.off(_constants2.EVENTS.CARD_SHOWN);
    this.eventEmitter.off(_constants2.EVENTS.CARD_HIDDEN);
  };

  CardsModule.prototype.destroy = function destroy() {
    if (!this.isInitialized) {
      return;
    }

    this.unbindEvents();

    this.cardsContainer.destroy();
    this.cardsManager.destroy();
    this.cardsConfig.destroy();

    if (this.resizeSensor) {
      this.resizeSensor.detach(this.handlePlayerSizeChange);
    }

    delete this.cardsContainer;
    delete this.cardsManager;
    delete this.cardsConfig;
  };

  return CardsModule;
}(), _class2.dependencies = ['eventEmitter', 'rootContainer', 'engine'], _temp), (_applyDecoratedDescriptor(_class.prototype, 'addCard', [_dec], Object.getOwnPropertyDescriptor(_class.prototype, 'addCard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addCards', [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, 'addCards'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeCard', [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, 'removeCard'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateCards', [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, 'updateCards'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearCards', [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, 'clearCards'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setAnchorPoint', [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, 'setAnchorPoint'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setOrientation', [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, 'setOrientation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onCardClose', [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, 'onCardClose'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onCardShown', [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, 'onCardShown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onCardHidden', [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, 'onCardHidden'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setCardsClosable', [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, 'setCardsClosable'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setActiveCard', [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, 'setActiveCard'), _class.prototype)), _class));
exports.default = CardsModule;